(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pluvia-buy-box"] && !Shopify.designMode) return;
  try {
    
(function(){
  "use strict";
  var form=document.getElementById("pluvia-buy"); if(!form) return;
  var idInput=document.getElementById("pv-variant-id"),
      planInput=document.getElementById("pv-selling-plan"),
      subBox=document.getElementById("t-sub-box"),
      refill=document.getElementById("refill-rate"),
      refillLine=document.getElementById("refill-line"),
      cancelLine=document.getElementById("cancel-line"),
      subPct=document.getElementById("sub-pct"),
      addBtn=document.getElementById("add"),
      radios=form.querySelectorAll('input[name="pv-pack"]');

  function selected(){
    for(var i=0;i<radios.length;i++) if(radios[i].checked) return radios[i];
    return radios[0]||null;
  }

  /* Prices are pre-rendered by Liquid; this only chooses which one shows. */
  function sync(){
    var r=selected(); if(!r) return;
    var subscribing = subBox ? subBox.checked : false;
    var plan = r.getAttribute("data-plan");
    idInput.value = r.value;
    if(planInput) planInput.value = (subscribing && plan) ? plan : "";
    var label = subscribing ? r.getAttribute("data-sub") : r.getAttribute("data-once");
    var priceEl = r.parentNode.querySelector("[data-price]");
    if(priceEl && label) priceEl.textContent = label;
    var best=0;
    Array.prototype.forEach.call(radios,function(x){
      x.parentNode.classList.toggle("is-on", x.checked);
      var sub=subscribing && x.getAttribute("data-plan");
      var p=x.parentNode.querySelector("[data-price]");
      var v=sub ? x.getAttribute("data-sub") : x.getAttribute("data-once");
      if(p&&v) p.textContent=v;
      /* strike and badge follow the price actually shown */
      var now=+(sub ? x.getAttribute("data-sub-c") : x.getAttribute("data-once-c")),
          was=+x.getAttribute("data-was-c"),
          pct=was>0 ? Math.round((1-now/was)*100) : 0;
      var s=x.parentNode.querySelector("[data-save]"), w=x.parentNode.querySelector("[data-was-el]");
      if(s){ s.textContent="Save "+pct+"%"; s.hidden=pct<1; }
      if(w) w.hidden=!(now<was);
      if(pct>best) best=pct;
    });
    /* the headline "Up To X% Off" is derived from the ladder, never typed */
    if(best>0) Array.prototype.forEach.call(document.querySelectorAll("[data-max-save]"),function(el){ el.textContent=best+"%"; });
    if(subPct && plan){
      var o=+r.getAttribute("data-once-c"), sc=+r.getAttribute("data-sub-c");
      if(o>0 && sc<o) subPct.textContent=Math.round((1-sc/o)*100);
    }
    if(refillLine) refillLine.hidden=!subscribing;
    if(cancelLine) cancelLine.hidden=!subscribing;
    /* per pouch, so "each" reads true on every tier */
    if(refill){ var u=r.getAttribute(subscribing?"data-rate-sub":"data-rate"); if(u) refill.textContent=u; }
  }

  Array.prototype.forEach.call(radios,function(r){ r.addEventListener("change",sync); });
  if(subBox) subBox.addEventListener("change",sync);
  sync();

  /* gallery: thumbs swap the main shot. The .ok class is re-applied by
     wirePhotos once the new file has decoded, so a failed swap falls back
     rather than leaving an empty frame. */
  var shotImg=document.getElementById("shot-img");
  var thumbs=document.querySelectorAll(".thumb");
  if(shotImg && thumbs.length){
    Array.prototype.forEach.call(thumbs,function(t){
      t.addEventListener("click",function(e){
        e.preventDefault();
        Array.prototype.forEach.call(thumbs,function(o){
          o.removeAttribute("aria-current"); o.classList.remove("is-on"); });
        t.setAttribute("aria-current","true"); t.classList.add("is-on");
        shotImg.classList.remove("ok");
        if(shotImg.parentElement) shotImg.parentElement.classList.remove("has");
        shotImg.removeAttribute("data-wired");
        shotImg.src=t.getAttribute("data-src");
        shotImg.alt=t.getAttribute("data-alt")||"";
        if(window.pluviaWirePhotos) window.pluviaWirePhotos(shotImg.parentElement);
      });
    });
  }

  /* P-10 · ship date. Orders before 2pm ship the same business day. */
  var shipEl=document.getElementById("ship-date");
  if(shipEl){
    var d=new Date(); if(d.getHours()>=14) d.setDate(d.getDate()+1);
    var add=2, guard=0;
    while(add>0 && guard++<30){ d.setDate(d.getDate()+1); if(d.getDay()!==0&&d.getDay()!==6) add--; }
    shipEl.textContent=d.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});
  }

  /* Cart AJAX — adding must not redirect. */
  form.addEventListener("submit",function(e){
    e.preventDefault();
    if(!idInput.value) return;
    var body={items:[{id:Number(idInput.value),quantity:1}]};
    if(planInput && planInput.value) body.items[0].selling_plan=Number(planInput.value);
    if(addBtn){ addBtn.disabled=true; addBtn.classList.add("is-loading"); }
    fetch("/cart/add.js",{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify(body)
    }).then(function(r){ return r.json(); })
      .then(function(){ document.dispatchEvent(new CustomEvent("pluvia:cart:added")); })
      .catch(function(){ form.submit(); })
      .finally(function(){ if(addBtn){ addBtn.disabled=false; addBtn.classList.remove("is-loading"); } });
  });

  /* G-04 · every "Try Risk Free Today" returns here. */
  document.addEventListener("click",function(e){
    var j=e.target.closest("[data-buy-jump]"); if(!j) return;
    e.preventDefault();
    var packs=document.getElementById("packs");
    if(packs) packs.scrollIntoView({behavior:"smooth",block:"center"});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pluvia-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  "use strict";
  var drawer=document.getElementById("drawer"), scrim=document.getElementById("scrim");
  if(!drawer||!scrim) return;
  var openBtn=document.getElementById("cart-open"),
      closeBtn=document.getElementById("cart-close"),
      linesEl=document.getElementById("d-lines"),
      emptyEl=document.getElementById("d-empty"),
      countEl=document.getElementById("d-count"),
      badgeEl=document.getElementById("cart-n"),
      subEl=document.getElementById("subtotal"),
      totEl=document.getElementById("d-total"),
      savRow=document.getElementById("d-savings"),
      savChip=document.getElementById("d-chip"),
      savAmt=document.getElementById("d-saved-total"),
      checkout=document.getElementById("checkout"),
      banner=document.getElementById("d-banner"),
      bannerT=document.getElementById("d-banner-t"),
      isOpen=false, timer=null, lastFocus=null;

  /* "id:pct id:pct" -> lookup. A flat string beats JSON in an attribute: no
     quoting to escape, and a malformed entry drops itself rather than throwing
     and taking the whole drawer down with it. */
  var PCTS = (function(){
    var out={}, raw = banner ? (banner.getAttribute("data-pcts")||"") : "";
    raw.split(/\s+/).forEach(function(pair){
      var bits=pair.split(":");
      if(bits.length===2 && bits[0] && bits[1]) out[bits[0]]=bits[1];
    });
    return out;
  })();
  var PCT_FALLBACK = banner ? (banner.getAttribute("data-fallback")||"") : "";
  var BANNER_TPL   = banner ? (banner.getAttribute("data-tpl")||"") : "";

  /* The pack the visitor actually committed to is the line with the most money
     in it, not the first one added. */
  function chosenVariant(cart){
    var best=null, bestVal=-1;
    (cart.items||[]).forEach(function(it){
      if(it.final_line_price>bestVal){ bestVal=it.final_line_price; best=it; }
    });
    return best ? String(best.variant_id) : null;
  }

  function syncBanner(cart){
    if(!banner) return;
    if(!cart.item_count){ banner.hidden=true; return; }
    var pct = PCTS[chosenVariant(cart)] || PCT_FALLBACK;
    if(!pct || !BANNER_TPL){ banner.hidden=true; return; }
    if(bannerT) bannerT.textContent = BANNER_TPL.replace(/\{pct\}/g, pct);
    banner.hidden=false;
  }

  function money(c){
    return "$" + (c/100).toFixed(2);
  }

  /* ── focus trap ── */
  function focusables(){
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'),
      function(el){ return el.offsetParent !== null; });
  }
  function onKey(e){
    if(e.key==="Escape"){ e.preventDefault(); setOpen(false); return; }
    if(e.key!=="Tab") return;
    var f=focusables(); if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }

  function setOpen(v){
    isOpen=v;
    drawer.setAttribute("aria-hidden", String(!v));
    clearTimeout(timer);
    if(v){
      lastFocus=document.activeElement;
      drawer.classList.add("open"); scrim.classList.add("open");
      void drawer.offsetWidth;
      drawer.classList.add("in"); scrim.classList.add("in");
      document.addEventListener("keydown", onKey);
      if(closeBtn) closeBtn.focus();
      refresh();
    } else {
      drawer.classList.remove("in"); scrim.classList.remove("in");
      document.removeEventListener("keydown", onKey);
      timer=setTimeout(function(){
        if(!isOpen){ drawer.classList.remove("open"); scrim.classList.remove("open"); }
      },300);
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }

  function render(cart){
    if(countEl) countEl.textContent=cart.item_count;
    if(badgeEl){ badgeEl.textContent=cart.item_count; badgeEl.hidden = cart.item_count===0; }
    if(subEl) subEl.textContent=money(cart.total_price);
    if(totEl) totEl.textContent=money(cart.total_price);
    if(emptyEl) emptyEl.hidden = cart.item_count>0;
    if(linesEl) linesEl.hidden = cart.item_count===0;
    syncBanner(cart);

    var saved=0;
    var html=cart.items.map(function(it){
      if(it.original_line_price>it.final_line_price) saved+=it.original_line_price-it.final_line_price;
      var img=it.image ? '<div class="d-img"><img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2')+'" alt="" loading="lazy"></div>' : '';
      var was=it.original_line_price>it.final_line_price
        ? '<span class="d-was">'+money(it.original_line_price)+'</span>' : '';
      return '<div class="d-line" data-key="'+it.key+'">'+img+
        '<div class="d-info"><p class="d-name">'+it.product_title+'</p>'+
        '<p class="d-var">'+(it.variant_title||"")+'</p>'+
        '<div class="d-qty"><button type="button" class="d-q" data-step="-1" aria-label="Decrease quantity">&minus;</button>'+
        '<span class="d-qn">'+it.quantity+'</span>'+
        '<button type="button" class="d-q" data-step="1" aria-label="Increase quantity">+</button></div></div>'+
        '<div class="d-prices"><span class="d-now">'+money(it.final_line_price)+'</span>'+was+'</div></div>';
    }).join("");
    if(linesEl) linesEl.innerHTML=html;
    if(window.pluviaWirePhotos) window.pluviaWirePhotos(linesEl);

    if(savRow){
      savRow.hidden = saved<=0;
      if(saved>0){
        if(savAmt) savAmt.textContent=money(saved);
        if(savChip) savChip.textContent=Math.round(saved/(cart.total_price+saved)*100)+"%";
      }
    }
  }

  function refresh(){
    return fetch("/cart.js",{headers:{"Accept":"application/json"}})
      .then(function(r){ return r.json(); }).then(render).catch(function(){});
  }

  function change(key,qty){
    return fetch("/cart/change.js",{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({id:key,quantity:qty})
    }).then(function(r){ return r.json(); }).then(render).catch(function(){});
  }

  if(linesEl) linesEl.addEventListener("click",function(e){
    var b=e.target.closest(".d-q"); if(!b) return;
    var line=b.closest(".d-line"); if(!line) return;
    var cur=parseInt(line.querySelector(".d-qn").textContent,10)||0;
    change(line.getAttribute("data-key"), Math.max(0,cur+parseInt(b.getAttribute("data-step"),10)));
  });

  if(openBtn) openBtn.addEventListener("click",function(){ setOpen(true); });
  if(closeBtn) closeBtn.addEventListener("click",function(){ setOpen(false); });
  scrim.addEventListener("click",function(){ setOpen(false); });
  if(checkout) checkout.addEventListener("click",function(){ window.location.href="/checkout"; });

  /* the buy box dispatches this after a successful /cart/add.js */
  document.addEventListener("pluvia:cart:added",function(){ setOpen(true); });
  document.addEventListener("pluvia:cart:open",function(){ setOpen(true); });

  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pluvia-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  "use strict";
  var island=document.getElementById("island"), addBtn=document.getElementById("add");
  if(!island) return;
  function show(){
    /* With a buy box on the page, geometry: the island is up exactly when the
       real Add to cart is off screen. Without one — the home page — there is
       nothing to track, so it appears once a screen has gone by, which is far
       enough that it reads as an offer rather than an interruption. */
    if(addBtn){
      var r=addBtn.getBoundingClientRect();
      return !(r.top < window.innerHeight && r.bottom > 0);
    }
    var sc=document.querySelector(".page-wrapper");
    var oy=sc?getComputedStyle(sc).overflowY:"";
    var y=(sc && (oy==="auto"||oy==="scroll")) ? sc.scrollTop
        : (window.scrollY||document.documentElement.scrollTop||0);
    return y > window.innerHeight * 0.9;
  }
  function sync(){
    var up=show();
    island.classList.toggle("up", up);
    document.body.classList.toggle("has-bar", up);
  }
  /* Horizon scrolls .page-wrapper, not the window, from 990px up — window never
     hears that scroll, so listen on document in the capture phase as well. */
  window.addEventListener("scroll", sync, {passive:true});
  document.addEventListener("scroll", sync, {passive:true, capture:true});
  window.addEventListener("resize", sync, {passive:true});
  sync();
})();

  } catch(e) { console.error(e); }
})();
})();
